'use client'

import Blogs from "./Blogs"
import Products from "./Products"
import Hero from "./Hero"
import AllProducts from "./AllProducts"
import { useHomeBlocks, type NormalizedHomeBlock } from "@/lib/commerce/hooks"

export default function Home({ vendor, homeBlocks: homeBlocksProp, subscription, activeCampaigns }: { vendor: any, homeBlocks?: any[], subscription?: any, wishlist?: any, activeCampaigns?: any[] }) {
  const blocks = useHomeBlocks({ vendor, homeBlocks: homeBlocksProp, subscription })

  const renderBlock = (b: NormalizedHomeBlock) => {
    switch (b.type) {
    case 'banner':
      return <Hero key={b.id} vendor={vendor} activeCampaigns={activeCampaigns || []} />
    case 'sale-products':
    case 'featured-products':
    case 'new-products':
    case 'category':
    case 'showcase':
      return <Products key={b.id} products={b.products || []} vendor={vendor} title={b.title || ''} limit={b.config?.limit} description={b.description} viewAllUrl={b.viewAllUrl} />
    case 'blogs':
      return <Blogs key={b.id} blogs={b.blogs || []} title={b.title} limit={b.config?.limit} description={b.description} />
    case 'all-products':
      return <AllProducts key={b.id} vendor={vendor} title={b.title} description={b.description} />
    default:
      return null
    }
  }

  return <>{blocks.map(renderBlock)}</>
}